var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[(_vm.deleted)?[_c('span',{style:(_vm.textStyle)},[_vm._v(_vm._s(_vm.value))]),_c('el-tooltip',{attrs:{"content":_vm.content,"placement":"right"}},[_c('v-icon',{staticClass:"ml-1 mt-n1",attrs:{"color":_vm.iconColor,"small":""}},[_vm._v(_vm._s(_vm.icon))])],1)]:[_vm._v(" "+_vm._s(_vm.value)+" ")]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }